<section class="card" [class.card--no-gutter]="hasGutter">
    <ng-container *ngIf="!hasBody">
        <h2 class="card__title" *ngIf="title">{{ title }}</h2>
        <ng-content></ng-content>
    </ng-container>
    <ng-container *ngIf="hasBody">
        <header class="card__head" *ngIf="title || subtitle">
            <div class="modal-info-button">
                <ng-content select="mg-ui-modal"></ng-content>
            </div>
            <div class="title">
                <h2 class="card__title">
                    <mg-ideal-icon *ngIf="icon === 'ideal'"></mg-ideal-icon>
                    {{ title }}
                </h2>
                <span class="card__subtitle" *ngIf="!!subtitle">
                    {{ subtitle }}
                    <a
                        *ngIf="subtitleLink && subtitleLinkLabel"
                        [href]="subtitleLink"
                        [target]="_blank"
                        [rel]="noopener"
                    >
                        {{ subtitleLinkLabel }}
                    </a>
                </span>
            </div>
        </header>
        <div class="card__body">
            <ng-content></ng-content>
        </div>
    </ng-container>
</section>
